import React, { useState, Fragment, useEffect } from 'react';
// import styles from "./ConTrend.module.css";
import { Card, Col, Input, Row, Select, Space, Spin, Table, Typography } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { fetchJsData } from '../../../../api';
import { crawl } from '../../../../api/util';
import { newApps, cardCss, tabPageCss } from './columns';
const { Text } = Typography;

const ScheduledCatChange = (props) => {
    const [load, setLoad] = useState(true);
    const [data, setData] = useState([]);
    const key = props.usrSch == 'Scheduled' ? 1 : props.usrSch == 'Deployed' ? 0 : 2;

    useEffect(() => {
        if (props.loader === false) {
            fetchData();
        }
        // console.log("props", props.loader);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.loader]);

    const fetchData = async () => {
        setLoad(true);
        const data = await fetchJsData({
            type: 'fetch',
            qry: 'fetWkCatChanges',
        });
        // console.log("data in pro mod");
        // console.log(data["data"]);
        setData(data['data']);
        setLoad(false);
    };

    return (
        <div>
            {/* Card */}
            <Row style={{ margin: '5px', padding: '1px' }}>
                {/* <Col className="gutter-row" span={1}></Col> */}
                <Col className="gutter-row" span={23}>
                    {!load ? (
                        <FetchTabSearch
                            submit={props.submit}
                            rel={props.rel}
                            usrRel={props.usrRel}
                            loader={props.loader}
                            usrSch={key}
                            data={data}
                            col={newApps}
                            usrSel="MODIFIED"
                        />
                    ) : (
                        <Card loading={props.loader} style={{ width: '100%', minHeight: '80vh' }}></Card>
                    )}
                </Col>
            </Row>
        </div>
    );
};

const FetchTabSearch = (props) => {
    const [searchVal, setSearchVal] = useState(null);
    const [filteredData, setFilteredData] = useState([]);
    const [origData, setOrigData] = useState([]);
    const [searchIndex, setSearchIndex] = useState([]);
    const [loading, setLoading] = useState(false);
    const schData = props.usrSch !== 2 ? props.data.filter((x) => x.scheduled === props.usrSch) : props.data;
    const schColIndicator = props.usrSch === 1 ? 'Scheduled Date' : props.usrSch === 0 ? 'Deployed Date' : 'Scheduled / Deployed Date';

    useEffect(() => {
        console.log('usr -', props.usrSch, props.rel);
        setLoading(true);

        // props.setLiveMenu({ release: false, topMenu: "S", botMenu: "1" });
        setOrigData(schData);
        setFilteredData(schData);
        const searchInd = schData.map((user) => {
            const allValues = crawl(user);
            return { allValues: allValues.toString() };
        });
        setSearchIndex(searchInd);
        // console.log("filter- ", filteredData, schData, props.data);
        setLoading(false);
    }, [props.usrSch]);

    useEffect(() => {
        if (searchVal) {
            const reqData = searchIndex.map((user, index) => {
                if (user.allValues.toLowerCase().indexOf(searchVal.toLowerCase()) >= 0) return origData[index];
                return null;
            });
            setFilteredData(
                reqData.filter((user) => {
                    if (user) return true;
                    return false;
                })
            );
        } else setFilteredData(origData);
    }, [searchVal, origData, searchIndex, props.usrSch]);

    return (
        <>
            <div>
                <Row gutter={16}>
                    <Col span={24}>
                        <Card
                            title={
                                loading ? (
                                    <div>
                                        <Spin size="small" />
                                    </div>
                                ) : (
                                    <Row>
                                        <Col spane={6}>
                                            <Space size="small">
                                                <Text>
                                                    {props.usrSch === 1
                                                        ? 'Scheduled'
                                                        : props.usrSch === 0
                                                        ? 'Deployed'
                                                        : 'All'}
                                                </Text>
                                                <Text>
                                                    Top App Category Changes (Subset of 'All App Categories', accounts
                                                    for 90% of App traffic across Netskope customer base)
                                                </Text>
                                            </Space>
                                        </Col>
                                    </Row>
                                )
                            }
                            loading={props.loader}
                            size="small"
                            // style={{ maxHeight: "80vh", overflow: "scroll" }}
                            style={{ minHeight: '80vh' }}
                            // bodyStyle={{ padding: "0", borderStyle: "hidden" }}
                            bodyStyle={cardCss}
                            headStyle={{ backgroundColor: '#F0F8FF', border: 0 }}
                            extra={
                                <Row>
                                    <Col span={21}>
                                        <Input
                                            onChange={(e) => setSearchVal(e.target.value)}
                                            prefix={<SearchOutlined className="site-form-item-icon" />}
                                            placeholder="Crawl Search"
                                            allowClear
                                        />
                                    </Col>
                                    <Col span={1}></Col>
                                    <Col className="gutter-row" span={2}>
                                        {' '}
                                        <div></div>
                                    </Col>
                                </Row>
                            }
                        >
                            <Fragment>
                                <Table
                                    rowKey="id"
                                    size="small"
                                    bordered
                                    scroll={{ x: 550, y: 900 }}
                                    style={{ margin: '2px' }}
                                    dataSource={filteredData}
                                    columns={props.col(filteredData.length, schColIndicator)}
                                    loading={loading}
                                    pagination={{
                                        pageSizeOptions: ['10', '30', '60', '100', '1000'],
                                        defaultPageSize: ['50'],
                                        showSizeChanger: true,
                                        // style: { padding: "0", marginBottom: "0" },
                                        style: tabPageCss,
                                    }}
                                />
                            </Fragment>
                        </Card>
                    </Col>
                </Row>
            </div>
        </>
    );
};

export default ScheduledCatChange;
